export const recursivePropsVerification = ({ schema, _key, target }) => {
  const targetProperties = Object.keys(target)
  for (const prop of targetProperties) {
    if (!Object.hasOwn(schema, prop)) delete target[prop]
  }

  for (let property in schema) {
    const typeOfProperty = typeof schema[property]
    const propertyValueSchema = schema[property]
    const isArray = Array.isArray(propertyValueSchema)
    const isObject = typeOfProperty === 'object' && !isArray

    const targetHasKey = Object.hasOwn(target, property)

    if (isObject) {
      if (!targetHasKey) {
        target[property] = propertyValueSchema
        continue
      }
      recursivePropsVerification({ schema: propertyValueSchema, _key: property, target: target[property] })
    }

    if (isArray) {
      if (!targetHasKey) target[property] = []
      else {
        for (const i in target[property]) {
          const expectedSchemaOfArrayItem = propertyValueSchema[0]
          const entryIsAnObject = typeof expectedSchemaOfArrayItem === 'object'
          const valueOfAnalyzedArrayItem = target[property][i]

          if (entryIsAnObject) recursivePropsVerification({ schema: expectedSchemaOfArrayItem, _key: null, target: valueOfAnalyzedArrayItem })
          else if (!entryIsAnObject && typeof expectedSchemaOfArrayItem !== typeof valueOfAnalyzedArrayItem) target[property].splice(i, 1)
        }
      }
    }

    if (!isObject && !isArray) {
      if (!targetHasKey) target[property] = propertyValueSchema
      else if (targetHasKey && target[property] === null) target[property] = propertyValueSchema
      else if (targetHasKey && typeof target[property] !== typeof propertyValueSchema) target[property] = propertyValueSchema
    }
  }
}
